import React from 'react';
import './KpiRenderer.css';

const KpiRenderer = ({ data, config, compact }) => {
  const { unit = '', trendValue } = config || {};
  
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <div className="dc-no-data">No data available</div>;
  }

  return (
    <div className={`dc-kpi-grid ${compact ? 'compact' : ''}`}>
      {data.map((item, index) => {
        // Robust value detection
        let value = item.value;
        if (value === undefined || value === null) {
            const firstNumeric = Object.values(item).find(v => typeof v === 'number');
            value = firstNumeric !== undefined ? firstNumeric : '—';
        }

        // Robust label detection
        let label = item.label;
        if (!label) {
            // Check for any string value
            label = Object.values(item).find(v => typeof v === 'string' && v !== item.trend);
        }
        if (!label) {
            // Check for any key that isn't a standard property or numeric
            label = Object.keys(item).find(k => k !== 'value' && k !== 'trend' && k !== 'trendValue' && k !== 'target' && k !== 'item');
        }

        const trend = item.trend || config?.trend || 'none';
        const isUp = trend === 'up';
        const isDown = trend === 'down';
        const trendColor = isUp ? 'var(--status-success)' : isDown ? 'var(--status-error)' : 'var(--text-tertiary)';

        return (
          <div key={index} className="dc-kpi-card">
            {label && <div className="dc-kpi-label">{label}</div>}
            <div className="dc-kpi-value-wrap">
              <span className="dc-kpi-value">{value}{unit}</span>
            </div>
            {(item.trendValue !== undefined || trendValue !== undefined) && (
              <div className="dc-kpi-trend" style={{ color: trendColor }}>
                {isUp ? '↑' : isDown ? '↓' : ''} {item.trendValue ?? trendValue}{unit}
              </div>
            )}
            {item.target !== undefined && (
              <div className="dc-kpi-target">Target: {item.target}{unit}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KpiRenderer;
